import { render, staticRenderFns } from "./DeleteSetModal.vue?vue&type=template&id=6c6fc2aa&"
import script from "./DeleteSetModal.vue?vue&type=script&lang=js&"
export * from "./DeleteSetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports